


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component({
    name: 'SearchNav',
})
export default class SearchNav extends Vue {
    @Prop({default: ''}) holder!: string
    @Prop({default: ''}) keyword!: string
    @Prop({default: false}) isFocus!: boolean
    @Prop({default: true}) showBack!: boolean

    keyValue = this.keyword
    @Watch('keyword')
    changeKeyword (val: string) {
        this.keyValue = val
    }

    created () {
        if (this.isFocus) {
            this.$nextTick(() => {
                (this.$refs.search as any).getElementsByTagName('input')[0].focus()
            })
        }
    }

    goBack () {
        this.$router.back()
    }

    onSearch () {
        this.$emit('searchFunc', this.keyValue)
    }

    changeClass (type: string) {
        if (type === '1') {
            (this.$refs.search as any).classList.add('focus')
        } else if (type === '2') {
            (this.$refs.search as any).classList.remove('focus')
        }
    }
}
